export default function PhoneIcon({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="12 9 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.7719 10.439L16.8479 10.095C17.8579 9.77299 18.9349 10.294 19.3679 11.312L20.2269 13.34C20.6009 14.223 20.3939 15.262 19.7129 15.908L17.8189 17.706C17.9349 18.782 18.2969 19.841 18.9029 20.883C19.4787 21.8912 20.2509 22.7736 21.1739 23.478L23.4489 22.718C24.3119 22.431 25.2509 22.762 25.7789 23.539L27.0119 25.349C27.6269 26.253 27.5169 27.499 26.7539 28.265L25.9359 29.086C25.1219 29.903 23.9589 30.2 22.8839 29.864C20.3449 29.072 18.0109 26.721 15.8809 22.811C13.7479 18.895 12.9949 15.571 13.6229 12.843C13.8869 11.695 14.7039 10.78 15.7719 10.439Z"
        fill="currentColor"
      />
    </svg>
  );
}
